// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 825 ? "npm.xlsx" : chunkId) + "." + {"663":"a1b5c620","712":"fcd9c92b","825":"33e55a59","1030":"3e395e55","1084":"49945ec2","2591":"491fe913","3076":"09fe8bc7","3576":"95e8d521","4931":"90fe70df","6927":"81fcd71c","7252":"6e2bba0a","7279":"7a507527","9888":"aa0ff30b"}[chunkId] + ".js";
};